// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CanaryCard from "../../resources/layout-and-structure/CanaryCard.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SettingsRoutes from "../../app/Settings/SettingsRoutes.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CanaryCardInfoSwap from "../../resources/layout-and-structure/CanaryCardInfoSwap.res.js";
import * as CompanyLegalNumber from "../CompanyLegalNumber.res.js";
import Illustration_e_invoicingSvg from "./illustration_e_invoicing.svg";

let illustrationSrc = Illustration_e_invoicingSvg;

function isShopFromBelgium(shop) {
  if (shop !== undefined) {
    return CountryCode.parseIso3166Alpha2(shop.country) === "BE";
  } else {
    return false;
  }
}

function make(schemeType, schemeCode, endpointId) {
  let match = Stdlib_Option.getOr(Stdlib_Option.map(schemeCode, prim => prim.trim()), "");
  let match$1 = Stdlib_Option.getOr(Stdlib_Option.map(endpointId, prim => prim.trim()), "");
  if (match === "" || match$1 === "") {
    return;
  } else {
    return {
      schemeType: schemeType,
      schemeCode: match,
      endpointId: match$1
    };
  }
}

function format(param) {
  return param.schemeCode + `:` + param.endpointId;
}

function formatOption(value) {
  return Stdlib_Option.getOr(Stdlib_Option.map(value, format), "");
}

let selectLabel = I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix_select.label");

function selectSection(options, toKey, toLabel) {
  return [{
      items: options.map(kind => ({
        TAG: "Option",
        key: toKey(kind),
        label: toLabel(kind),
        value: kind
      })),
      title: I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix_select.section_title")
    }];
}

let schemeCode = "0225";

let options = [
  "Siren",
  "SirenWithSuffix",
  "Siret",
  "SiretWithRoutingCode"
];

function toKey(value) {
  switch (value) {
    case "Siren" :
      return "SIREN";
    case "SirenWithSuffix" :
      return "SIREN_WITH_SUFFIX";
    case "Siret" :
      return "SIRET";
    case "SiretWithRoutingCode" :
      return "SIRET_WITH_ROUTING_CODE";
  }
}

function toLabel(value) {
  switch (value) {
    case "Siren" :
      return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siren");
    case "SirenWithSuffix" :
      return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siren_with_suffix");
    case "Siret" :
      return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siret");
    case "SiretWithRoutingCode" :
      return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.prefix.siret_with_routing_code");
  }
}

function toSchemeType(value) {
  switch (value) {
    case "Siren" :
      return "FR_SIREN";
    case "SirenWithSuffix" :
      return "FR_SIREN_SUFFIX";
    case "Siret" :
      return "FR_SIREN_SIRET";
    case "SiretWithRoutingCode" :
      return "FR_SIREN_SIRET_CODEROUTAGE";
  }
}

function fromSchemeType(value) {
  return options.find(option => toSchemeType(option) === value);
}

let selectSections = selectSection(options, toKey, toLabel);

function identifierIsSiren(value) {
  switch (value) {
    case "Siren" :
    case "SirenWithSuffix" :
      return true;
    case "Siret" :
    case "SiretWithRoutingCode" :
      return false;
  }
}

function isValidComplement(value) {
  let value$1 = value.trim();
  if (value$1.length <= 100) {
    return /^[0-9A-Za-z._-]+$/.test(value$1);
  } else {
    return false;
  }
}

function identifierLabel(value) {
  if (identifierIsSiren(value)) {
    return I18n.t("SIREN number");
  } else {
    return I18n.t("SIRET number");
  }
}

function identifierPlaceholder(value) {
  if (identifierIsSiren(value)) {
    return I18n.t("electronic_invoicing.invoicing_endpoint.siren.placeholder");
  } else {
    return I18n.t("siret_input_field.placeholder");
  }
}

function validateIdentifier(value, identifier) {
  if (identifierIsSiren(value)) {
    if (CompanyLegalNumber.French.isValidSiren(identifier)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("electronic_invoicing.invoicing_endpoint.siren.error_message")
      };
    }
  } else if (CompanyLegalNumber.French.isValidSiret(identifier)) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: I18n.t("siret_input_field.error_message")
    };
  }
}

let complementErrorMessage = I18n.t("electronic_invoicing.invoicing_endpoint.complement.error_message");

function validateSuffix(value, suffix) {
  if (value === "SirenWithSuffix" && !isValidComplement(suffix)) {
    return {
      TAG: "Error",
      _0: complementErrorMessage
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function validateRoutingCode(value, routingCode) {
  if (value === "SiretWithRoutingCode" && !isValidComplement(routingCode)) {
    return {
      TAG: "Error",
      _0: complementErrorMessage
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function endpointId(value, siret, suffix, routingCode) {
  let siren = CompanyLegalNumber.French.sirenFromSiret(siret);
  switch (value) {
    case "Siren" :
      return siren;
    case "SirenWithSuffix" :
      return siren + "_" + suffix.trim();
    case "Siret" :
      return siren + "_" + siret;
    case "SiretWithRoutingCode" :
      return siren + "_" + siret + "_" + routingCode.trim();
  }
}

function makeEndpoint(value, siret, suffix, routingCode) {
  return make(toSchemeType(value), schemeCode, endpointId(value, siret, suffix, routingCode));
}

function complementFromEndpointId(endpointId, precedingParts) {
  return endpointId.split("_").slice(precedingParts).join("_");
}

function fromEndpoint(schemeType, endpointId) {
  let complement = precedingParts => Stdlib_Option.mapOr(endpointId, "", __x => complementFromEndpointId(__x, precedingParts));
  let kind = Stdlib_Option.flatMap(schemeType, fromSchemeType);
  if (kind === undefined) {
    return [
      "Siren",
      "",
      ""
    ];
  }
  switch (kind) {
    case "SirenWithSuffix" :
      return [
        "SirenWithSuffix",
        complement(1),
        ""
      ];
    case "Siren" :
    case "Siret" :
      return [
        kind,
        "",
        ""
      ];
    case "SiretWithRoutingCode" :
      return [
        "SiretWithRoutingCode",
        "",
        complement(2)
      ];
  }
}

let French = {
  schemeCode: schemeCode,
  options: options,
  toKey: toKey,
  toLabel: toLabel,
  toSchemeType: toSchemeType,
  fromSchemeType: fromSchemeType,
  selectSections: selectSections,
  identifierIsSiren: identifierIsSiren,
  complementMaxLength: 100,
  isValidComplement: isValidComplement,
  identifierLabel: identifierLabel,
  identifierPlaceholder: identifierPlaceholder,
  validateIdentifier: validateIdentifier,
  complementErrorMessage: complementErrorMessage,
  validateSuffix: validateSuffix,
  validateRoutingCode: validateRoutingCode,
  endpointId: endpointId,
  makeEndpoint: makeEndpoint,
  complementFromEndpointId: complementFromEndpointId,
  fromEndpoint: fromEndpoint
};

let options$1 = [
  "BceNumber",
  "VatNumber"
];

function schemeCode$1(value) {
  if (value === "BceNumber") {
    return "0208";
  } else {
    return "9925";
  }
}

function toKey$1(value) {
  if (value === "BceNumber") {
    return "BCE_NUMBER";
  } else {
    return "VAT_NUMBER";
  }
}

function toLabel$1(value) {
  if (value === "BceNumber") {
    return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.be_label");
  } else {
    return I18n.t("customer_new_page.billing_fieldset.invoicing_endpoint.be_vat_label");
  }
}

function toSchemeType$1(value) {
  if (value === "BceNumber") {
    return "BE_BCE";
  } else {
    return "BE_TVA";
  }
}

function fromSchemeType$1(value) {
  return options$1.find(option => toSchemeType$1(option) === value);
}

let selectSections$1 = selectSection(options$1, toKey$1, toLabel$1);

function endpointId$1(value, vatNumber) {
  if (value === "BceNumber") {
    return CompanyLegalNumber.Belgian.bceFromVatNumber(vatNumber);
  } else {
    return CompanyLegalNumber.Vat.normalize(vatNumber);
  }
}

function identifierLabel$1(value) {
  if (value === "BceNumber") {
    return I18n.t("BCE number");
  } else {
    return I18n.t("VAT number");
  }
}

function identifierPlaceholder$1(value) {
  if (value === "BceNumber") {
    return I18n.t("electronic_invoicing.invoicing_endpoint.bce.placeholder");
  } else {
    return I18n.t("electronic_invoicing.invoicing_endpoint.vat.placeholder");
  }
}

function isValidIdentifier(value, identifier) {
  if (value === "BceNumber") {
    return CompanyLegalNumber.Belgian.isValidBce(CompanyLegalNumber.Vat.normalize(identifier));
  } else {
    return CompanyLegalNumber.Belgian.isValidVatNumber(identifier);
  }
}

function validateIdentifier$1(value, identifier) {
  if (isValidIdentifier(value, identifier)) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let tmp;
  tmp = value === "BceNumber" ? I18n.t("electronic_invoicing.invoicing_endpoint.bce.error_message") : I18n.t("electronic_invoicing.invoicing_endpoint.vat.error_message");
  return {
    TAG: "Error",
    _0: tmp
  };
}

function makeEndpoint$1(value, vatNumber) {
  return make(toSchemeType$1(value), schemeCode$1(value), endpointId$1(value, vatNumber));
}

let Belgian = {
  options: options$1,
  schemeCode: schemeCode$1,
  toKey: toKey$1,
  toLabel: toLabel$1,
  toSchemeType: toSchemeType$1,
  fromSchemeType: fromSchemeType$1,
  selectSections: selectSections$1,
  endpointId: endpointId$1,
  identifierLabel: identifierLabel$1,
  identifierPlaceholder: identifierPlaceholder$1,
  isValidIdentifier: isValidIdentifier,
  validateIdentifier: validateIdentifier$1,
  makeEndpoint: makeEndpoint$1
};

let InvoicingEndpoint = {
  make: make,
  format: format,
  formatOption: formatOption,
  selectLabel: selectLabel,
  selectSection: selectSection,
  French: French,
  Belgian: Belgian
};

function ElectronicInvoicing$Card(props) {
  let featureState = props.featureState;
  let tmp;
  tmp = featureState !== undefined && typeof featureState !== "object" ? JsxRuntime.jsx(NextBadge.make, {
      kind: "Neutral",
      label: I18n.t("Inactive{{feminine}}"),
      size: "S"
    }) : null;
  let headerElement = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(NextBadge.make, {
        kind: "Information",
        label: I18n.t("BETA"),
        size: "XS"
      }),
      JsxRuntime.jsx(CanaryCard.Title.make, {
        children: I18n.t("electronic_invoicing.card.title")
      }),
      Primitive_object.equal(featureState, "Inactive") ? JsxRuntime.jsx(CanarySeparator.make, {
          size: "auto",
          spacing: "xs"
        }) : null,
      tmp
    ],
    space: "xsmall"
  });
  let headerEndElement = typeof featureState === "object" ? JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      tooltipText: I18n.t("electronic_invoicing.card.settings_button_tooltip.text"),
      icon: "legacy_settings",
      href: SettingsRoutes.electronicInvoicingRoute
    }) : null;
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: props.children,
    headerElement: headerElement,
    headerEndElement: headerEndElement
  });
}

let Card = {
  make: ElectronicInvoicing$Card
};

function ElectronicInvoicing$InactiveCardContent(props) {
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx("img", {
            style: {
              margin: "auto",
              width: "120px"
            },
            alt: "e-invoicing",
            src: illustrationSrc
          }),
          JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsx(Title.make, {
                  children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.title"),
                  level: 3,
                  align: "center",
                  weight: "bold",
                  color: "#25243A"
                }),
                spaceBottom: "xmedium"
              }),
              JsxRuntime.jsxs(InlineText.make, {
                children: [
                  JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_1"),
                    size: "small"
                  }),
                  JsxRuntime.jsx(TextStyle.make, {
                    children: " eFacture (Cecurity)",
                    weight: "semibold",
                    size: "small"
                  }),
                  JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content.part_2"),
                    size: "small"
                  }),
                  JsxRuntime.jsx("br", {}),
                  JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_1"),
                    weight: "semibold",
                    size: "small"
                  }),
                  JsxRuntime.jsx(TextStyle.make, {
                    children: ", " + I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.content_caption_part_2"),
                    size: "small"
                  })
                ],
                align: "center"
              })
            ],
            space: "none"
          }),
          JsxRuntime.jsxs(Inline.make, {
            children: [
              JsxRuntime.jsx(Button.make, {
                tone: {
                  NAME: "neutral",
                  VAL: {
                    accent: true
                  }
                },
                size: "medium",
                icon: "help_center",
                tooltipText: I18n.t("electronic_invoicing.inactive_card_content.help_center_button.label"),
                onPress: () => HelpCenter.showArticle(HelpCenter.eInvoicingHowTo)
              }),
              JsxRuntime.jsx(Button.make, {
                label: I18n.t("settings_electronic_invoicing_page.account_setup_fieldset.content.create_button_label"),
                variant: {
                  NAME: "ghost",
                  VAL: {
                    bordered: true
                  }
                },
                tone: "brand",
                size: "medium",
                trailingIcon: "arrow_right",
                href: SettingsRoutes.electronicInvoicingSetupRoute
              })
            ],
            space: "xnormal",
            align: "center"
          })
        ],
        space: "large"
      }),
      spaceX: "large",
      spaceY: "xlarge"
    })
  });
}

let InactiveCardContent = {
  make: ElectronicInvoicing$InactiveCardContent
};

function toString(value) {
  return "cecurity";
}

let Platform = {
  toString: toString
};

let options$2 = [
  "BasicVatExemption",
  "Simplified",
  "NormalMonthly",
  "NormalQuarterly",
  "Other"
];

function toRaw(value) {
  switch (value) {
    case "BasicVatExemption" :
      return "BASIC_VAT_EXEMPTION";
    case "Simplified" :
      return "SIMPLIFIED";
    case "NormalMonthly" :
      return "NORMAL_MONTHLY";
    case "NormalQuarterly" :
      return "NORMAL_QUARTERLY";
    case "Other" :
      return "OTHER";
  }
}

function fromRaw(value) {
  return options$2.find(option => toRaw(option) === value);
}

function fromShop(shop) {
  return Stdlib_Option.flatMap(shop.taxationRegime, fromRaw);
}

function toLabel$2(value) {
  switch (value) {
    case "BasicVatExemption" :
      return I18n.t("electronic_invoicing.taxation_regime.basic_vat_exemption");
    case "Simplified" :
      return I18n.t("electronic_invoicing.taxation_regime.simplified");
    case "NormalMonthly" :
      return I18n.t("electronic_invoicing.taxation_regime.normal_monthly");
    case "NormalQuarterly" :
      return I18n.t("electronic_invoicing.taxation_regime.normal_quarterly");
    case "Other" :
      return I18n.t("electronic_invoicing.taxation_regime.other");
  }
}

let selectSections$2 = [{
    items: options$2.map(value => ({
      TAG: "Option",
      key: toRaw(value),
      label: toLabel$2(value),
      value: value
    }))
  }];

let TaxationRegime = {
  options: options$2,
  toRaw: toRaw,
  fromRaw: fromRaw,
  fromShop: fromShop,
  toLabel: toLabel$2,
  selectSections: selectSections$2
};

let options$3 = [
  "From1To10",
  "From11To20",
  "From21To50",
  "From51To250",
  "AtLeast251"
];

function toRaw$1(value) {
  switch (value) {
    case "From1To10" :
      return "FROM_1_TO_10";
    case "From11To20" :
      return "FROM_11_TO_20";
    case "From21To50" :
      return "FROM_21_TO_50";
    case "From51To250" :
      return "FROM_51_TO_250";
    case "AtLeast251" :
      return "AT_LEAST_251";
  }
}

function fromRaw$1(value) {
  return options$3.find(option => toRaw$1(option) === value);
}

function fromShop$1(shop) {
  return Stdlib_Option.flatMap(shop.employeesNumber, fromRaw$1);
}

function toLabel$3(value) {
  switch (value) {
    case "From1To10" :
      return `1 – 10`;
    case "From11To20" :
      return `11 – 20`;
    case "From21To50" :
      return `21 – 50`;
    case "From51To250" :
      return `51 – 250`;
    case "AtLeast251" :
      return I18n.t("electronic_invoicing.employees_number.at_least_251");
  }
}

let selectSections$3 = [{
    items: options$3.map(value => ({
      TAG: "Option",
      key: toRaw$1(value),
      label: toLabel$3(value),
      value: value
    }))
  }];

let EmployeesNumber = {
  options: options$3,
  toRaw: toRaw$1,
  fromRaw: fromRaw$1,
  fromShop: fromShop$1,
  toLabel: toLabel$3,
  selectSections: selectSections$3
};

function fromRaw$2(value) {
  switch (value) {
    case "INACTIVE" :
      return "Inactive";
    case "PENDING" :
      return "Pending";
    case "SIGNED" :
      return "Signed";
    case "TO_SEND" :
      return "ToSend";
    default:
      return;
  }
}

function toLabel$4(value) {
  switch (value) {
    case "Inactive" :
      return I18n.t("Inactive{{feminine}}");
    case "ToSend" :
      return I18n.t("Available");
    case "Pending" :
      return I18n.t("electronic_invoicing.settings.enrollment_status.pending_label");
    case "Signed" :
      return I18n.t("Enabled{{feminine}}");
  }
}

function toStyleSet(value) {
  switch (value) {
    case "Inactive" :
      return {
        bgColor: "#FAD0E3",
        textColor: "#821938",
        borderColor: "#F8A9CC"
      };
    case "ToSend" :
      return {
        bgColor: "#F3F3F7",
        textColor: "#25243A",
        borderColor: "#D7D7E0"
      };
    case "Pending" :
      return {
        bgColor: "#FFE5CF",
        textColor: "#7C2112",
        borderColor: "#FDAB74"
      };
    case "Signed" :
      return {
        bgColor: "#EBFEF3",
        textColor: "#00653E",
        borderColor: "#66EFAC"
      };
  }
}

let Badge = {
  toStyleSet: toStyleSet
};

let EnrollmentStatus = {
  fromRaw: fromRaw$2,
  toLabel: toLabel$4,
  Badge: Badge
};

function makeBaseEndpoint(shopId, platformOpt) {
  return Env.gatewayUrl() + `/documents-digitization-platform/` + "cecurity" + `/` + shopId;
}

function messageFromFailure(failure) {
  switch (failure) {
    case "AccountNotFound" :
      return;
    case "Failure" :
      return I18n.t("electronic_invoicing.settings_request.failure");
    case "UnexpectedFailure" :
      return I18n.t("electronic_invoicing.settings_request.unexpected_failure");
  }
}

function makeEndpoint$2(shopId) {
  return makeBaseEndpoint(shopId, undefined) + "/settings";
}

function decodeEmissionSubscription(json) {
  let dict = Json.decodeDict(json);
  let id = Json.flatDecodeDictFieldString(dict, "id");
  if (id !== undefined) {
    return {
      id: id
    };
  }
}

function decodeEnrollmentAgreementStatus(value) {
  return Stdlib_Option.flatMap(Json.decodeString(value), fromRaw$2);
}

function decodeReceptionSubscription(json) {
  let dict = Json.decodeDict(json);
  let status = Json.flatDecodeDictField(dict, "enrollmentAgreementStatus", decodeEnrollmentAgreementStatus);
  if (status === undefined) {
    return;
  }
  let id = Json.flatDecodeDictFieldString(dict, "id");
  let link = Json.flatDecodeDictFieldString(dict, "enrollmentAgreementLink");
  return {
    id: id,
    enrollmentAgreementStatus: status,
    enrollmentAgreementLink: link
  };
}

function decodeUser(json) {
  let dict = Json.decodeDict(json);
  let match = Json.flatDecodeDictFieldString(dict, "id");
  let match$1 = Json.flatDecodeDictFieldString(dict, "loginName");
  let match$2 = Json.flatDecodeDictFieldString(dict, "emailAddress");
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined) {
    return {
      id: match,
      loginName: match$1,
      emailAddress: match$2
    };
  }
}

function decodeResult(json) {
  let dict = Json.decodeDict(json);
  let receptionHasRequiredFields = (reception, receptionFlag) => {
    if (receptionFlag) {
      return true;
    }
    if (!Stdlib_Option.isSome(reception.id)) {
      return false;
    }
    let match = reception.enrollmentAgreementStatus;
    switch (match) {
      case "ToSend" :
      case "Pending" :
        return Stdlib_Option.isSome(reception.enrollmentAgreementLink);
      case "Inactive" :
      case "Signed" :
        return true;
    }
  };
  let match = Json.flatDecodeDictField(dict, "electronicInvoicingEmissionSubscription", decodeEmissionSubscription);
  let match$1 = Json.flatDecodeDictField(dict, "electronicInvoicingReceptionSubscription", decodeReceptionSubscription);
  let match$2 = Json.flatDecodeDictField(dict, "user", decodeUser);
  let match$3 = Json.flatDecodeDictFieldString(dict, "accountLink");
  let match$4 = Json.flatDecodeDictFieldBoolean(dict, "usingThirdPartyElectronicInvoicingEmission");
  let match$5 = Json.flatDecodeDictFieldBoolean(dict, "usingThirdPartyElectronicInvoicingReception");
  if (match !== undefined && match$1 !== undefined && match$2 !== undefined && match$3 !== undefined && match$4 !== undefined && match$5 !== undefined && receptionHasRequiredFields(match$1, match$5)) {
    return {
      user: match$2,
      accountLink: match$3,
      emissionSubscription: match,
      receptionSubscription: match$1,
      usingThirdPartyEmission: match$4,
      usingThirdPartyReception: match$5
    };
  }
}

function decodeInvalidRequestFailure(error) {
  switch (error.kind) {
    case "GetShopIdCecurityAccountNotFound" :
    case "NotFoundShopElectronicInvoicingPlatform" :
      return "AccountNotFound";
    case "MissingPermissions" :
    case "SchemaValidation" :
      return "Failure";
    default:
      return "UnexpectedFailure";
  }
}

function mapFutureResult(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, decodeResult), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure), "UnexpectedFailure");
    }
  });
}

function make$1(shopId) {
  return mapFutureResult(Request.make(makeEndpoint$2(shopId), "GET", undefined, undefined, undefined));
}

let SettingsRequest = {
  messageFromFailure: messageFromFailure,
  makeEndpoint: makeEndpoint$2,
  decodeEmissionSubscription: decodeEmissionSubscription,
  decodeEnrollmentAgreementStatus: decodeEnrollmentAgreementStatus,
  decodeReceptionSubscription: decodeReceptionSubscription,
  decodeUser: decodeUser,
  decodeResult: decodeResult,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  mapFutureResult: mapFutureResult,
  make: make$1
};

function messageFromFailure$1(failure) {
  switch (failure) {
    case "AlreadyLinkedSiretFailure" :
      return I18n.t("electronic_invoicing.setup_request.already_linked_siret_failure");
    case "AlreadyLinkedVatNumberFailure" :
      return I18n.t("electronic_invoicing.setup_request.already_linked_vat_number_failure");
    case "Failure" :
      return I18n.t("electronic_invoicing.setup_request.failure");
    case "UnexpectedFailure" :
      return I18n.t("electronic_invoicing.setup_request.unexpected_failure");
  }
}

function makeEndpoint$3(shopId) {
  return makeBaseEndpoint(shopId, undefined) + "/setup";
}

function encodeBodyJson(email, userFirstName, userLastName, siretNumber, vatNumber, corporateName, taxationRegime, employeesNumber) {
  return Json.encodeDict(Object.fromEntries([
    [
      "email",
      Json.encodeString(email)
    ],
    [
      "userFirstName",
      Json.encodeString(userFirstName)
    ],
    [
      "userLastName",
      Json.encodeString(userLastName)
    ],
    [
      "siretNumber",
      siretNumber !== undefined ? Json.encodeString(siretNumber) : null
    ],
    [
      "vatNumber",
      vatNumber !== undefined ? Json.encodeString(vatNumber) : null
    ],
    [
      "corporateName",
      Json.encodeString(corporateName)
    ],
    [
      "taxationRegime",
      Json.encodeString(toRaw(taxationRegime))
    ],
    [
      "employeesNumber",
      Json.encodeString(toRaw$1(employeesNumber))
    ]
  ]));
}

function decodeInvalidRequestFailure$1(error) {
  switch (error.kind) {
    case "SiretAlreadyLinkedToEInvoicingAccount" :
      return "AlreadyLinkedSiretFailure";
    case "CecurityDuplicateCustomerName" :
    case "CecurityDuplicateUserLoginName" :
    case "MissingElectronicInvoicingIdentifier" :
    case "MissingPermissions" :
    case "SchemaValidation" :
    case "UnsupportedCountryForElectronicInvoicing" :
      return "Failure";
    case "VatNumberAlreadyLinkedToEInvoicingAccount" :
      return "AlreadyLinkedVatNumberFailure";
    default:
      return "UnexpectedFailure";
  }
}

function mapFutureResult$1(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, param => {}), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$1), "UnexpectedFailure");
    }
  });
}

function make$2(shopId, email, userFirstName, userLastName, siretNumber, vatNumber, corporateName, taxationRegime, employeesNumber) {
  return mapFutureResult$1(Request.make(makeEndpoint$3(shopId), "POST", {
    TAG: "JsonBody",
    _0: encodeBodyJson(email, userFirstName, userLastName, siretNumber, vatNumber, corporateName, taxationRegime, employeesNumber)
  }, undefined, true));
}

let SetupRequest = {
  messageFromFailure: messageFromFailure$1,
  makeEndpoint: makeEndpoint$3,
  encodeBodyJson: encodeBodyJson,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$1,
  mapFutureResult: mapFutureResult$1,
  make: make$2
};

function messageFromFailure$2(failure) {
  if (failure === "Failure") {
    return I18n.t("electronic_invoicing.update_settings_request.failure");
  } else {
    return I18n.t("electronic_invoicing.update_settings_request.unexpected_failure");
  }
}

function makeEndpoint$4(shopId) {
  return makeBaseEndpoint(shopId, undefined) + "/settings";
}

function encodeBodyJson$1(usingThirdPartyReception) {
  return Json.encodeDict(Object.fromEntries([[
      "usingThirdPartyElectronicInvoicingReception",
      Json.encodeBoolean(usingThirdPartyReception)
    ]]));
}

function decodeInvalidRequestFailure$2(error) {
  switch (error.kind) {
    case "EnrollmentSigned" :
    case "MissingAuthorizationHeader" :
    case "MissingPermissions" :
    case "SchemaValidation" :
      return "Failure";
    default:
      return "UnexpectedFailure";
  }
}

function mapFutureResult$2(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, param => {}), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnexpectedFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$2), "UnexpectedFailure");
    }
  });
}

function make$3(shopId, usingThirdPartyReception) {
  return mapFutureResult$2(Request.make(makeEndpoint$4(shopId), "PATCH", {
    TAG: "JsonBody",
    _0: encodeBodyJson$1(usingThirdPartyReception)
  }, undefined, true));
}

let UpdateSettingsRequest = {
  messageFromFailure: messageFromFailure$2,
  makeEndpoint: makeEndpoint$4,
  encodeBodyJson: encodeBodyJson$1,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$2,
  mapFutureResult: mapFutureResult$2,
  make: make$3
};

function messageFromFailure$3(failure) {
  switch (failure) {
    case "ShopArchivedFailure" :
      return I18n.t("This shop has been archived.");
    case "NotFoundShopFailure" :
      return I18n.t("This shop does not exist.");
    case "Failure" :
    case "UnexpectedFailure" :
      return Request.serverErrorMessage;
  }
}

let endpoint = Env.gatewayUrl() + "/shop";

function encodeBody(id, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType) {
  return Json.encodeDict(Object.fromEntries([
    [
      "id",
      Json.encodeString(id)
    ],
    [
      "invoicingEndpointId",
      Stdlib_Option.mapOr(invoicingEndpointId, null, Json.encodeString)
    ],
    [
      "invoicingEndpointIdSchemeCode",
      Stdlib_Option.mapOr(invoicingEndpointIdSchemeCode, null, Json.encodeString)
    ],
    [
      "invoicingEndpointIdSchemeType",
      Stdlib_Option.mapOr(invoicingEndpointIdSchemeType, null, Json.encodeString)
    ]
  ]));
}

function decodeInvalidRequestFailure$3(serverFailure) {
  switch (serverFailure.kind) {
    case "AuthUserFromHttpRequestFailureCase" :
    case "CheckUserPermissionsFailureCase" :
      return "Failure";
    case "NotFoundShopFailure" :
      return "NotFoundShopFailure";
    case "ShopArchivedFailure" :
      return "ShopArchivedFailure";
    default:
      return "UnexpectedFailure";
  }
}

function make$4(id, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType) {
  return Future.mapError(Request.make(endpoint, "PATCH", {
    TAG: "JsonBody",
    _0: encodeBody(id, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType)
  }, undefined, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$3);
    }
  });
}

let UpdateShopInvoicingAddressRequest = {
  messageFromFailure: messageFromFailure$3,
  endpoint: endpoint,
  encodeBody: encodeBody,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$3,
  make: make$4
};

let failureMessage = I18n.t("electronic_invoicing.download_contract_request.failure");

function makeEndpoint$5(shopId) {
  return makeBaseEndpoint(shopId, undefined) + "/enrollment-contract";
}

function make$5(shopId) {
  return Future.mapError(Request.makeBlob(makeEndpoint$5(shopId), undefined), undefined, param => "ServerFailure");
}

let DownloadContractRequest = {
  failureMessage: failureMessage,
  makeEndpoint: makeEndpoint$5,
  make: make$5
};

let Settings = {
  EnrollmentStatus: EnrollmentStatus,
  makeBaseEndpoint: makeBaseEndpoint,
  SettingsRequest: SettingsRequest,
  SetupRequest: SetupRequest,
  UpdateSettingsRequest: UpdateSettingsRequest,
  UpdateShopInvoicingAddressRequest: UpdateShopInvoicingAddressRequest,
  DownloadContractRequest: DownloadContractRequest
};

function receivingEnabledFromSettings(settings) {
  let match = settings.receptionSubscription.enrollmentAgreementStatus;
  let match$1 = settings.usingThirdPartyReception;
  if (match$1) {
    return true;
  }
  switch (match) {
    case "ToSend" :
    case "Pending" :
      return false;
    case "Inactive" :
    case "Signed" :
      return true;
  }
}

function featureStateResultFromSettingsRequestResult(result) {
  if (result.TAG === "Ok") {
    let settings = result._0;
    if (settings !== undefined) {
      return {
        TAG: "Ok",
        _0: {
          TAG: "Active",
          receivingEnabled: receivingEnabledFromSettings(settings),
          enrollmentAgreementLink: settings.receptionSubscription.enrollmentAgreementLink
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  }
  switch (result._0) {
    case "AccountNotFound" :
      return {
        TAG: "Ok",
        _0: "Inactive"
      };
    case "Failure" :
    case "UnexpectedFailure" :
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function useActiveFeatureState(shopId) {
  let match = React.useState(() => "NotAsked");
  let setState = match[1];
  React.useEffect(() => {
    if (shopId !== undefined) {
      setState(AsyncData.toBusy);
      let future = Future.tap(make$1(shopId), result => setState(param => ({
        TAG: "Done",
        _0: featureStateResultFromSettingsRequestResult(result)
      })));
      return () => Future.cancel(future);
    }
    setState(param => "NotAsked");
  }, [shopId]);
  return match[0];
}

export {
  illustrationSrc,
  isShopFromBelgium,
  InvoicingEndpoint,
  Card,
  InactiveCardContent,
  Platform,
  TaxationRegime,
  EmployeesNumber,
  Settings,
  receivingEnabledFromSettings,
  featureStateResultFromSettingsRequestResult,
  useActiveFeatureState,
}
/* illustrationSrc Not a pure module */
